import { TableCell } from '@/components/ui/table';
import { WarrantyCoverageStatusBadge } from '@/warranty-v3/components/warranty-coverage-status-badge';
import type { UnitOverviewRow } from '@/warranty-v3/entities/overview';

type CoverageStatusCellProps = {
  row: UnitOverviewRow;
};

export function CoverageStatusCell({ row }: CoverageStatusCellProps) {
  return (
    <TableCell narrow justify="left" className="whitespace-nowrap">
      {row.coverageStatus ? (
        <WarrantyCoverageStatusBadge status={row.coverageStatus} />
      ) : (
        '-'
      )}
    </TableCell>
  );
}
